export function compareFileNames(a: File, b: File): number {
    return a.name.localeCompare(b.name)
}

export async function readFileContents(fileBlob: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            const textContent = event.target?.result;
            resolve(textContent ?? '');
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsText(fileBlob);
    });
}